(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-anio', {
            parent: 'entity',
            url: '/ss-anio',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSAnios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-anio/s-s-anios.html',
                    controller: 'SSAnioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-anio-detail', {
            parent: 'ss-anio',
            url: '/ss-anio/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSAnio'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-anio/ss-anio-detail.html',
                    controller: 'SSAnioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSAnio', function($stateParams, SSAnio) {
                    return SSAnio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-anio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-anio-detail.edit', {
            parent: 'ss-anio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-dialog.html',
                    controller: 'SSAnioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAnio', function(SSAnio) {
                            return SSAnio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-anio.new', {
            parent: 'ss-anio',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-dialog.html',
                    controller: 'SSAnioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                anio: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-anio', null, { reload: 'ss-anio' });
                }, function() {
                    $state.go('ss-anio');
                });
            }]
        })
        .state('ss-anio.edit', {
            parent: 'ss-anio',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-dialog.html',
                    controller: 'SSAnioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSAnio', function(SSAnio) {
                            return SSAnio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-anio', null, { reload: 'ss-anio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-anio.delete', {
            parent: 'ss-anio',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-anio/ss-anio-delete-dialog.html',
                    controller: 'SSAnioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSAnio', function(SSAnio) {
                            return SSAnio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-anio', null, { reload: 'ss-anio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
